import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UserManagementComponent } from './user/user-management/user-management.component';
import { AuthenticationErrorPageComponent } from './authentication-error-page/authentication-error-page.component';

const routes: Routes = [
  { path: '', component:  UserManagementComponent},
  { path: 'errorPage', component:  AuthenticationErrorPageComponent}
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
